import React from 'react'
import styled from '@emotion/styled'

const Root = styled.div`
  padding: ${({noLeftPadding}) => noLeftPadding ? '25px 25px 25px 0' : '25px'};
  color: black;
  font-size: 16px;
  font-weight: 500;
`

const Loading = ({noLeftPadding}) => <Root noLeftPadding={noLeftPadding}>
  Загрузка...
</Root>

export default Loading
